/**
 * @file 号码卡片
 * @author (zhaomiaoyuan@baidu.com)
 */

import React from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';

import MicroCard from './microCard';
import SearchResult from './searchResult';

import './landingPage.less';

const LandingPage = props => {
    const {hasMicroCard, landingPageDetail} = props;
    return (
        <div className="landing-page">
            <div className="landing-page-shadow"></div>
            <div className="landing-page-content">
                {hasMicroCard ? (
                    <MicroCard microCard={landingPageDetail} />
                ) : (
                    <SearchResult searchResult={landingPageDetail} />
                )}
            </div>
        </div>
    );
};
LandingPage.propTypes = {
    history: PropTypes.any,
    hasMicroCard: PropTypes.bool,
    landingPageDetail: PropTypes.object
};

export default withRouter(LandingPage);
